/**
 * Bottom nav Oleum: carrito, favoritos, cuenta y badge del carrito.
 * El drawer del carrito solo se mueve a <body> en mobile (≤1024px); en desktop permanece en el header.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 1024px)');
  var cartDrawerHome = null;

  function isBottomNavViewport() {
    return MOBILE_MQ.matches;
  }

  function updateCartBadge(count) {
    document.querySelectorAll('[data-oleum-bottom-nav-cart-badge]').forEach(function (badge) {
      var countEl = badge.querySelector('[data-oleum-bottom-nav-cart-count]');
      if (!countEl) return;
      var n = typeof count === 'number' ? count : parseInt(countEl.textContent || '0', 10);
      countEl.textContent = n > 0 && n < 100 ? String(n) : n >= 100 ? '99+' : '0';
      badge.classList.toggle('oleum-bottom-nav__cart-badge--empty', n <= 0);
    });
  }

  function syncCartBadgeFromHeader() {
    var source = document.querySelector('[data-testid="cart-bubble"]');
    if (!source) return;
    var n = parseInt(source.textContent || '0', 10);
    if (!isNaN(n)) updateCartBadge(n);
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function rememberCartDrawerHome(drawer) {
    if (cartDrawerHome || !drawer) return;
    cartDrawerHome = drawer.closest('header-actions') || drawer.parentElement;
  }

  function restoreCartDrawerToHeader() {
    var drawer = getCartDrawer();
    if (!drawer) return drawer;

    rememberCartDrawerHome(drawer);
    drawer.classList.remove('oleum-cart-drawer--mobile-portal');

    if (cartDrawerHome && cartDrawerHome.isConnected && drawer.parentElement !== cartDrawerHome) {
      cartDrawerHome.appendChild(drawer);
    }

    delete drawer.dataset.oleumCartMobilePortal;
    return drawer;
  }

  function mountCartDrawerForMobile() {
    var drawer = getCartDrawer();
    if (!drawer) return drawer;

    rememberCartDrawerHome(drawer);

    if (!isBottomNavViewport()) {
      return restoreCartDrawerToHeader();
    }

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.classList.add('oleum-cart-drawer--mobile-portal');
    drawer.dataset.oleumCartMobilePortal = '1';
    return drawer;
  }

  function syncCartDrawerPlacement() {
    if (isBottomNavViewport()) {
      mountCartDrawerForMobile();
    } else {
      restoreCartDrawerToHeader();
    }
  }

  function openCartDrawer() {
    var drawer = isBottomNavViewport() ? mountCartDrawerForMobile() : restoreCartDrawerToHeader();

    if (!drawer) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    var trigger = drawer.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      return;
    }

    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  function scrollToHashTarget(hash) {
    if (!hash || hash.charAt(0) !== '#') return false;
    var target = document.querySelector(hash);
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) {
      history.replaceState(null, '', hash);
    } else {
      window.location.hash = hash.slice(1);
    }
    return true;
  }

  function handleFavoritesClick(event, link) {
    var href = (link.getAttribute('href') || '').trim();
    if (!href) return;

    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    var hash = href.slice(hashIndex);
    var pathPart = href.slice(0, hashIndex);
    var onSamePage =
      href.charAt(0) === '#' ||
      pathPart === window.location.pathname ||
      pathPart === window.location.pathname + '/' ||
      (pathPart === '' && window.location.pathname === '/');

    if (!onSamePage) return;

    if (scrollToHashTarget(hash)) {
      event.preventDefault();
    }
  }

  function bindFavoritesLinks(scope) {
    (scope || document).querySelectorAll('[data-oleum-bottom-nav-favorites]').forEach(function (link) {
      if (link.dataset.oleumFavoritesBound === '1') return;
      link.dataset.oleumFavoritesBound = '1';
      link.addEventListener('click', function (event) {
        handleFavoritesClick(event, link);
      });
    });
  }

  function getAccountWidget() {
    return (
      document.querySelector('.oleum-account-access--header shopify-account') ||
      document.querySelector('shopify-account')
    );
  }

  function clickAccountWidget(widget) {
    if (!widget) return false;

    try {
      var root = widget.shadowRoot;
      if (root) {
        var trigger =
          root.querySelector('[part="signed-out-avatar"]') ||
          root.querySelector('button') ||
          root.querySelector('[role="button"]');
        if (trigger && typeof trigger.click === 'function') {
          trigger.click();
          return true;
        }
      }
    } catch (e) {
      /* shadow cerrado o no listo */
    }

    if (typeof widget.click === 'function') {
      widget.click();
      return true;
    }

    widget.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    return true;
  }

  function openAccountAccess(fallback) {
    var widget = getAccountWidget();
    if (widget && clickAccountWidget(widget)) return true;

    if (fallback && fallback.href) {
      window.location.href = fallback.href;
      return true;
    }

    window.location.href = (window.routes && window.routes.account_login_url) || '/account/login';
    return false;
  }

  function bindAccountAccess(scope) {
    (scope || document).querySelectorAll('[data-oleum-account-access]').forEach(function (wrap) {
      if (wrap.dataset.oleumAccountBound === '1') return;
      wrap.dataset.oleumAccountBound = '1';

      var widget = wrap.querySelector('shopify-account');
      var fallback = wrap.querySelector('[data-oleum-account-fallback]');
      var isProxy = wrap.hasAttribute('data-oleum-account-proxy');
      var proxyBtn = wrap.querySelector('[data-oleum-account-proxy-btn]');

      // Solo el botón proxy (bottom-nav) debe interceptar el click.
      // Si interceptamos clicks sobre <shopify-account>, preventDefault
      // rompe Orders / Profile del menú nativo de Shopify.
      if (isProxy || proxyBtn) {
        wrap.addEventListener('click', function (event) {
          if (event.target.closest('a[data-oleum-account-fallback]')) return;
          event.preventDefault();
          openAccountAccess(fallback);
        });
        return;
      }

      if (!widget && typeof customElements !== 'undefined') {
        customElements.whenDefined('shopify-account').then(function () {
          if (!getAccountWidget() && fallback) {
            fallback.classList.remove('visually-hidden');
          }
        }).catch(function () {
          if (fallback) fallback.classList.remove('visually-hidden');
        });
      }
    });
  }

  function mountBottomNav(root) {
    if (!root || root.dataset.oleumBottomNavMounted === '1') return;

    document.querySelectorAll('[data-oleum-bottom-nav]').forEach(function (existing) {
      if (existing !== root) existing.remove();
    });

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    root.dataset.oleumBottomNavMounted = '1';
    document.body.classList.add('oleum-has-bottom-nav');
  }

  function initBottomNav(root) {
    if (!root || root.dataset.oleumBottomNavReady === '1') return;
    mountBottomNav(root);
    syncCartDrawerPlacement();
    root.dataset.oleumBottomNavReady = '1';

    root.querySelectorAll('[data-oleum-bottom-nav-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openCartDrawer();
      });
    });

    bindFavoritesLinks(root);
    bindAccountAccess(root);
    syncCartBadgeFromHeader();

    document.addEventListener('cart:update', function (event) {
      var itemCount = event.detail && event.detail.data ? event.detail.data.itemCount : undefined;
      if (typeof itemCount === 'number') updateCartBadge(itemCount);
    });
  }

  function boot(scope) {
    syncCartDrawerPlacement();
    bindFavoritesLinks(scope);
    bindAccountAccess(scope);
    (scope || document).querySelectorAll('[data-oleum-bottom-nav]').forEach(initBottomNav);
  }

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', syncCartDrawerPlacement);
  } else if (typeof MOBILE_MQ.addListener === 'function') {
    MOBILE_MQ.addListener(syncCartDrawerPlacement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    cartDrawerHome = null;
    boot(event.target);
  });
})();
